"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.raritiesWithOracle = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.raritiesWithOracle = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '1',
        abi: abis_1.abis.RaritiesWithOracle,
        address: '0xb9957735bbe6D42585058Af11AA72da8eAD9043a',
        name: 'Decentraland Rarities with Oracle',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '1',
        abi: abis_1.abis.RaritiesWithOracle,
        address: '0xA9158E22F89Bb3F69c5600338895Cb5FB81e5090',
        name: 'Decentraland Rarities with Oracle',
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=raritiesWithOracle.js.map